import getContacts from './GetContacts';
import getRosterEntries from './GetRosterEntries';
import getCredentials from './GetCredentials';
import getSubmit from './GetSubmit';

const getLeftNavigationState = (viewName, route, orgUnitAthleteEntryInfoState) => {

  const items = [
    getContacts(viewName, route, orgUnitAthleteEntryInfoState),
    getRosterEntries(viewName, route, orgUnitAthleteEntryInfoState),
    getCredentials(viewName, route, orgUnitAthleteEntryInfoState),
    getSubmit(viewName, route, orgUnitAthleteEntryInfoState)
  ];

  return items;
};

export default getLeftNavigationState;